import graphqlClient from '~/graphql/graphqlClient';

export interface MutationEquipAbilityArgs {
  playerId: string;
  heroHandle: string;
  abilityHandle: string;
  heroBuildId: string;
}

export interface AbilityChangeResult {
  heroHandle: string;
  heroBuild: any;
}

const mutation = `
mutation EquipAbility(
  $playerId: String!
  $heroHandle: String!
  $abilityHandle: String!
  $heroBuildId: String!
) {
  equipAbility(
    playerId: $playerId
    heroHandle: $heroHandle
    abilityHandle: $abilityHandle
    heroBuildId: $heroBuildId
  ) {
    heroHandle
    heroBuild
  }
}`;

export default async function mutationEquipAbility(args: MutationEquipAbilityArgs) {
  return await graphqlClient.request<AbilityChangeResult>('equipAbility', mutation, args);
}
